var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iw-textarea',{attrs:{"max-length":250,"input-id":"input-extend-info","input-label":_vm.$t('reason_info'),"input-optional":true,"input-style":"input--textarea--masquerade"},on:{"update-value":_vm.updateInfo}})}
var staticRenderFns = []

export { render, staticRenderFns }